<kendo-grid #loadsGrid
            [data]="gridData"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [sort]="gridState.sort"
            [filter]="gridState.filter"
            [pageable]="true"
            [sortable]="true"
            [filterable]="true"
            [resizable]="true"
            [autoSize]="true"
            (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column title="Action">
        <ng-template kendoGridCellTemplate let-load>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="orderPriority" title="Priority">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [hidden]="viewType=='orders'" field="quoteOrderLineID" title="Quote #">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="trailer" title="Trailer">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [hidden]="viewType!='rfq'" field="loadType" title="Type">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="mode" title="Mode">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="rateIndex" title="Rate Index">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-load>
            {{load.rateIndex}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [hidden]="viewType=='orders'" field="billTo" title="Bill To">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="originCity" title="O-City">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="originState" title="O-State">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="destinationCity" title="D-City">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="destinationState" title="D-State">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="isRoundTrip" title="RT">
        <ng-template kendoGridCellTemplate let-load>
            <!--<input type="checkbox" [checked]="load.isRoundTrip" disabled />-->
            <i *ngIf="load.isRoundTrip!=true" class="far fa-square fa-lg text-secondary"></i>
            <i *ngIf="load.isRoundTrip==true" class="fas fa-check-square fa-lg text-primary"></i>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="earliestDate" title="Earliest">
        <ng-template kendoGridCellTemplate let-load>
            {{load.earliestDate == '' ? '' : load.earliestDate | date: 'HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="latstDate" title="Latest">
        <ng-template kendoGridCellTemplate let-load>
            {{load.latestDate == '' ? '' : load.latestDate | date: 'HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="arrivalStartDate" title="{{viewType == 'rfq' ? 'Due' : 'Start'}}">
        <ng-template kendoGridCellTemplate let-load>
            {{load.arrivalStartDate == '' ? '' : load.arrivalStartDate | date: 'M/dd'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="orderNumber" title="Order #">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/order-entry', load.quoteOrderID]">{{load.orderNumber}}-{{ load.legNumber}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [hidden]="viewType!='orders'" field="loadType" title="Type">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="targetCost" title="Target">
        <ng-template kendoGridCellTemplate let-load>
            {{load.targetCost == null ? '' : load.targetCost | currency}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="maxCarrierPay" title="Max Pay">
        <ng-template kendoGridCellTemplate let-load>
            {{load.maxCarrierPay == null ? '' : load.maxCarrierPay | currency}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [hidden]="viewType=='orders'" field="finalCost" title="Final Cost">
        <ng-template kendoGridCellTemplate let-load>
            {{load.finalCost == null ? '' : load.finalCost | currency}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [hidden]="viewType!='orders'" field="isCostPlus" title="Cost Plus">
        <ng-template kendoGridCellTemplate let-load>
            <i *ngIf="load.isCostPlus!=true" class="far fa-square fa-lg text-secondary"></i>
            <i *ngIf="load.isCostPlus==true" class="fas fa-check-square fa-lg text-primary"></i>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [hidden]="viewType!='rfq'&&viewType!='quotes'&&viewType!='open-dedicated'" field="frequency" title="Frequency">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="assignedToName" title="Assigned">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-load>
            {{load.assignedToName}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="accountManagerName" title="Acct Mgr">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="repsAssigned" title="Reps">
    </kendo-grid-column>
    <kendo-grid-column field="offers" title="HC">
    </kendo-grid-column>
    <kendo-grid-column field="minutesSinceLastOffer" title="Last Call">
    </kendo-grid-column>
    <kendo-grid-column field="minBidRate" title="Min Rate" format="{0:c}">
    </kendo-grid-column>
    <!--<kendo-grid-column title="Tags">
        <ng-template kendoGridCellTemplate let-load>
            <span *ngFor="let tag of getTagTypes(load.tagTypes)">
                <tagtype-tag [tag]="tag"></tagtype-tag>
            </span>
        </ng-template>
    </kendo-grid-column>-->
</kendo-grid>
